import { useState } from "react";
import {
  Box,
  Card,
  Typography,
  TextField,
  IconButton,
} from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const SectionCard = ({ children }) => (
  <Card
    sx={{
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      padding: 2,
      marginBottom: 0.5,
    }}
  >
    {children}
  </Card>
);

const LabelWithIcon = ({ label, color }) => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Typography sx={{ fontWeight: 500, color: color }}>{label}</Typography>
      <IconButton size="small">
        <ChevronRightIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

const LabelWithInput = ({
  label,
  value,
  onChange,
  multiline,
  maxLength,
  color,
  secondaryText,
  alignItems = "center",
}) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems={alignItems}
      width="100%"
      className="disabled-container"
    >
      <Typography
        sx={{ fontWeight: "500", color: color, marginRight: 1 }}
        gutterBottom
      >
        {label}
      </Typography>
      <Box display="flex" flexDirection="column" alignItems="flex-end">
        <TextField
          sx={{ width: 150 }}
          size="small"
          placeholder="Text"
          variant="outlined"
          multiline={multiline}
          rows={multiline ? 2 : undefined}
          value={value}
          inputProps={maxLength ? { maxLength } : {}}
          onChange={onChange}
          className="input-field"
        />
        {maxLength && (
          <Box display="flex" justifyContent="flex-start" width="100%">
            <Typography variant="caption" color={secondaryText}>
              {value.length}/{maxLength}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default function MassContactPreview({ primaryText, secondaryText }) {
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");

  return (
    <>
      <SectionCard>
        <LabelWithIcon color={primaryText} label="Select Group" />
      </SectionCard>

      <SectionCard>
        <LabelWithInput
          label="Subject"
          color={primaryText}
          secondaryText={secondaryText}
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />
      </SectionCard>

      <SectionCard>
        <LabelWithInput
          color={primaryText}
          secondaryText={secondaryText}
          alignItems="flex-start"
          label="Body"
          value={body}
          onChange={(e) => setBody(e.target.value)}
          multiline
          maxLength={100}
        />
      </SectionCard>

      <SectionCard>
        <LabelWithIcon
          color={primaryText}
          secondaryText={secondaryText}
          label="Log As"
        />
      </SectionCard>
    </>
  );
}
